import React, {Component} from 'react';
import {locale} from "../locale/AppLocale"
import {connect} from 'react-redux'
import Loader from '../Components/Loader';
import * as productSearchActions from '../actions/productSearchActions'


import {
    Link
} from 'react-router-dom'

class SearchCategory extends Component {

    componentWillMount() {
        this.props.updateKeyword(decodeURIComponent(this.props.match.params.keyword));
        this.props.searchCategories(this.props.match.params.keyword);
    }


    componentWillUnmount(){
        this.props.updateKeyword('');
    }

    render() {
        return (
            <div>
                <Loader
                    completed={this.props.productSearch.fetchingCategories}>
                    <div className="category-pick">
                        {(this.props.productSearch.categories.length === 0 || this.props.productSearch.keyword.length<3) ? (
                                <div>
                                    <div className="category-pick--head no-mb">
                                        {locale.get('no_products_found_by_search') }
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            ) : (
                            <div>
                                <div className="category-pick--head">
                                    {locale.get('what_type_of_product') + ' ' + this.props.productSearch.keyword + ' ؟ '}
                                </div>
                                <div className="clearfix"></div>
                                <div>
                                    {this.props.productSearch.categories.map((category,index) => {
                                        return (
                                            <Link
                                                className="category-pick--link category-pick--has-icon btn-2"
                                                key={index} to={`/${this.props.match.params.businessSlug}/search/k/`+  encodeURIComponent(this.props.productSearch.keyword) + '/'+category.id}>
                                                <i className={category.category_class} /> <span className="title">{category.name} ({category.count}) </span>

                                            </Link>

                                        )
                                    })}
                                </div>
                            </div>
                            )}
                        <div className="clearfix"></div>
                        {/*<button className="category-pick--more btn-1">{ locale.get('load_more_categories')}</button>*/}
                    </div>
                </Loader>
            </div>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        productSearch:state.productSearch
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        searchCategories:(keyword)=>dispatch(productSearchActions.fetchCategoriesByKeyword(keyword)),
        updateKeyword:(keyword)=>dispatch(productSearchActions.updateKeyword(keyword)),
        searchProducts:(keyword,categoryId, scrollId, isNewCategory)=>dispatch(productSearchActions.fetchProducts(keyword,categoryId,'',isNewCategory)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchCategory);